import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-bg2 py-16 px-5" data-id="element-66">
      <div className="container-custom" data-id="element-67">
        <div className="max-w-[600px] mx-auto bg-[rgba(34,197,94,0.07)] border border-[rgba(34,197,94,0.25)] rounded-2xl p-10 text-center" data-id="element-68">
          <span className="text-[52px] block mb-4" data-id="element-69">🛡️</span>
          <h3 className="font-bebas text-[34px] text-green mb-3.5 tracking-[0.5px]" data-id="element-70">
            GARANTÍA "AMALO O DEVOLVELO"
          </h3>
          <p className="text-[16px] text-muted leading-[1.7] max-w-[440px] mx-auto" data-id="element-71">
            Probalo por{' '}
            <strong className="text-green font-bold" data-id="element-72">
              30 días completos sin riesgo
            </strong>
            . Si no quedás satisfecha por cualquier motivo, mandás un email y te
            devolvemos el 100% de tu dinero.{' '}
            <strong className="text-text font-bold" data-id="element-73">
              Sin preguntas. Sin letra chica. Sin vuelta.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}